export default {
    'could_not_issue_the_death_certificate': 'Could not issue the death certificate',
    'could_not_print': 'Could not print',
    'interim_claim_x_drafted': 'Interim claim {number} drafted',
    'could_not_raise_the_interim_claim': 'Could not raise the interim claim',
    'loading_the_admission': 'Loading the admission…',
    'that_admission_could_not_be_opened': 'That admission could not be opened.',
    'full_record': 'Full record',
    'statement': 'Statement',
    'new_order': 'New order',
    'transfer_bed': 'Transfer bed',
    'interim_claim': 'Interim claim',
    'discharge': 'Discharge',
    'death_certificate': 'Death certificate',
    'discharge_summary': 'Discharge summary',
    'allergies': 'Allergies',
    'pre_authorisation_needed': 'Pre-authorisation needed',
    'open_insurance': 'Open insurance',
    'this_patient_left_without_notice': 'This patient left without notice.',
    'of_their_advance_was_not_refunded_it_is_kept_as': 'of their advance was not refunded; it is kept as an advance held until someone decides what to do with it. See the Dues register.',
    'status': 'Status',
    'billed': 'Billed',
    'advances_payments': 'Advances + payments',
    'owing': 'Owing',
    'credit': 'Credit',
    'investigations': 'Investigations',
    'notes': 'Notes',
    'vitals': 'Vitals',
    'running_bill': 'Running bill',
    'advances': 'Advances',
    'daily_charges': 'Daily charges',
    'no_doses_scheduled_in_this_window': 'No doses scheduled in this window.',
    'due': 'Due',
    'medicine': 'Medicine',
    'high_alert': 'high alert',
    'given_at': 'Given at',
    'record': 'Record',
    'doctor_progress_notes': 'Doctor progress notes',
    'add_note': 'Add note',
    'no_progress_notes_yet': 'No progress notes yet.',
    'nursing_notes_and_handovers': 'Nursing notes and handovers',
    'no_nursing_notes_yet': 'No nursing notes yet.',
    'record_vitals': 'Record vitals',
    'no_vitals_recorded': 'No vitals recorded.',
    'recorded': 'Recorded',
    'bp': 'BP',
    'pulse': 'Pulse',
    'temp': 'Temp',
    'spo': 'SpO₂',
    'print': 'Print',
    'interim': 'interim',
    'final': 'final',
    'bill': 'bill',
    'description': 'Description',
    'qty': 'Qty',
    'amount': 'Amount',
    'progress_note_added': 'Progress note added',
    'nursing_note_added': 'Nursing note added',
    'could_not_save_the_note': 'Could not save the note',
    'doctor_progress_note': 'Doctor progress note',
    'nursing_note': 'Nursing note',
    'soap_format': 'SOAP format',
    'free_entry_or_an_sbar_handover': 'Free entry, or an SBAR handover',
    'cancel': 'Cancel',
    'save_note': 'Save note',
    'subjective': 'Subjective',
    'objective': 'Objective',
    'assessment': 'Assessment',
    'plan': 'Plan',
    'type': 'Type',
    'shift': 'Shift',
    'situation': 'Situation',
    'recommendation': 'Recommendation',
    'note': 'Note',
    'dose_recorded': 'Dose recorded',
    'could_not_record_the_dose': 'Could not record the dose',
    'x_x_due_x': '{dose} {route} · due {scheduledAt}',
    'high_alert_medicine_a_second_nurse_must_witness': 'High-alert medicine. A second nurse must witness the administration, and it cannot be you.',
    'outcome': 'Outcome',
    'newborn': 'Newborn',
    'witnessed_by': 'Witnessed by',
    'select_the_second_nurse': 'Select the second nurse…',
    'site': 'Site',
    'left_forearm_right_deltoid': 'Left forearm, right deltoid…',
    'reason': 'Reason',
    'a_dose_that_was_not_given_needs_an_explanation': 'A dose that was not given needs an explanation',
    'this_dose_is_more_than_an_hour_early_say_why': 'This dose is more than an hour early; say why it is being given now',
    'nobody_else_can_witness_this_dose': 'Nobody else on the staff can witness this dose',
    'order': 'Order',
    'dose': 'Dose',
    'route': 'Route',
    'frequency': 'Frequency',
    'instructions': 'Instructions',
    'patient_transferred': 'Patient transferred',
    'the_new_bed_class_is_charged_from_now': 'The new bed class is charged from now',
    'the_tariff_changes_from_the_moment_of_transfer': 'The tariff changes from the moment of transfer',
    'transfer': 'Transfer',
    'destination_bed': 'Destination bed',
    'select_a_free_bed': 'Select a free bed…',
    'patient_discharged': 'Patient discharged',
    'gate_pass_issued_and_the_bed_sent_for_cleaning': 'Gate pass issued and the bed sent for cleaning',
    'unused_advance_not_refunded': 'Unused advance not refunded',
    'x_stays_on_account_x': '{value} stays on account. {advanceRefundHeldBecause}',
    'charges_after_the_discharge_day': 'Charges after the discharge day',
    'x_was_billed_after_the_discharge_on_a_settled_bill': '{value} was billed for days after the discharge on a bill that is paid or claimed. Raise a credit note for it.',
    'the_summary_is_signed_by_you_and_printed_for': 'The summary is signed by you and printed for the patient',
    'this_bed_has_no_bed_day_charge': 'This bed has no bed-day charge',
    'nothing_has_been_posted_for_the_stay_itself_set': 'Nothing has been posted for the stay itself. Set a charge item on the bed under Branches → wards so the next admission bills automatically; add the bed days to this bill by hand before discharging.',
    'work_still_open_on_this_admission': 'Work still open on this admission',
    'pending_results_will_still_land_on_the_patients': '. Pending results will still land on the patient\'s record; tell the family how they will receive them.',
    'account_short_by_x': 'Account short by {value}',
    'discharge_anyway_i_take_responsibility_for_the': 'Discharge anyway — I take responsibility for the outstanding balance',
    'reason_for_the_override': 'Reason for the override',
    'settle_the_account_to_discharge_only_a_head': 'Settle the account to discharge. Only a head nurse or an administrator can discharge a patient who still owes a balance; a death or an absconding needs no clearance.',
    'discharge_type': 'Discharge type',
    'final_diagnosis': 'Final diagnosis',
    'procedures': 'Procedures',
    'hospital_course': 'Hospital course',
    'condition_at_discharge': 'Condition at discharge',
    'medication_on_discharge': 'Medication on discharge',
    'follow_up_instructions': 'Follow-up instructions',
    'could_not_update_the_request': 'Could not update the request',
    're_order_x': 'Re-order: {label}',
    'requests_from_clinics': 'Requests from clinics',
    'no_requests': 'No requests.',
    'asked': 'Asked',
    'patient': 'Patient',
    'urgency': 'Urgency',
    'ward': 'Ward',
    'admit': 'Admit',
    'admissions': 'Admissions',
    'current_in_patients_and_their_consultants': 'Current in-patients and their consultants',
    'admit_patient': 'Admit patient',
    'admission_number_patient_name_or_mrn': 'Admission number, patient name or MRN',
    'no_admissions_match': 'No admissions match.',
    'admission': 'Admission',
    'bed': 'Bed',
    'consultant': 'Consultant',
    'source': 'Source',
    'admitted': 'Admitted',
    'load_more': 'Load more',
    'patient_admitted': 'Patient admitted',
    'the_bed_is_occupied_and_the_running_bill_has': 'The bed is occupied and the running bill has started',
    'admit_a_patient': 'Admit a patient',
    'occupies_the_bed_takes_the_advance_and_opens': 'Occupies the bed, takes the advance and opens the running bill',
    'bed_class': 'Bed class',
    'any_class': 'Any class',
    'no_free_beds_of_this_class': 'No free beds of this class',
    'admitting_consultant': 'Admitting consultant',
    'ws_account_position': 'Account position',
    'ws_add': 'Add',
    'ws_add_doctor': 'Add doctor',
    'ws_add_doctor_desc': 'Co-consultants share the patient; residents and medical officers work under the primary consultant.',
    'ws_added_by_x_on_x': 'Added by {name} on {date}',
    'ws_admit_care_team_hint': 'The admitting consultant is the primary consultant. Add co-consultants and residents here; nurses come from the ward roster.',
    'ws_admitted': 'Admitted',
    'ws_admitted_on_x': 'Admitted on {date}',
    'ws_admitted_to': 'Admitted to',
    'ws_advances_desc': 'Money taken in advance, refunds and receipts',
    'ws_allergies_not_recorded': 'Allergies not recorded',
    'ws_approved_until': 'Approved until',
    'ws_approved_until_x': 'Approved until {date}',
    'ws_bed': 'Bed',
    'ws_bed_class': 'Bed class',
    'ws_bed_desc': 'Where the patient is now and every move since admission',
    'ws_before_discharge': 'Before discharge',
    'ws_bill_desc': 'Everything posted to this stay so far, grouped by where it came from',
    'ws_bill_print_hint': 'The running bill as it stands, itemised',
    'ws_by_x': 'by {name}',
    'ws_care_team': 'Care team',
    'ws_care_team_desc': 'One primary consultant, with co-consultants and residents for this stay',
    'ws_change_primary': 'Change primary consultant',
    'ws_change_primary_desc': 'The new primary consultant leads the stay from now on and counts as the admitting doctor from the next posting.',
    'ws_check_account_owing': 'The account is short by {amount}',
    'ws_check_account_settled': 'The account is settled',
    'ws_check_doses_done': 'No medication doses are waiting',
    'ws_check_doses_open': '{count, plural, one {# medication dose is still due} other {# medication doses are still due}}',
    'ws_check_imaging_done': 'Imaging is complete',
    'ws_check_imaging_open': '{count, plural, one {# imaging study is not yet released} other {# imaging studies are not yet released}}',
    'ws_check_lab_done': 'Lab work is complete',
    'ws_check_lab_open': '{count, plural, one {# lab test is not yet released} other {# lab tests are not yet released}}',
    'ws_choose_a_doctor': 'Choose a doctor',
    'ws_could_not_change_the_care_team': 'Could not change the care team',
    'ws_current_bed': 'Current bed',
    'ws_daily_charges_desc': 'Recurring charges posted every day for this patient, and pauses for this stay',
    'ws_day_x': 'Day {n}',
    'ws_death_certificate_hint': 'Issue and print the medical certificate of cause of death',
    'ws_diagnosis': 'Diagnosis',
    'ws_discharge_desc': 'Check what is still open, then complete the discharge',
    'ws_discharge_summary_desc': 'The summary the patient takes home',
    'ws_doctor': 'Doctor',
    'ws_doctor_n': 'Doctor {n}',
    'ws_doctors_on_this_admission': 'Doctors on this admission',
    'ws_documents_desc': 'Bills, summaries and certificates to print',
    'ws_doses_due': 'Doses due',
    'ws_doses_due_x': '{count, plural, one {# dose is due} other {# doses are due}}',
    'ws_emar_desc': 'Doses due in the last and next 24 hours',
    'ws_emr_emar': 'eMAR',
    'ws_emr_group_chart': 'Chart',
    'ws_emr_group_forms': 'Forms and orders',
    'ws_emr_menu': 'IPD EMR menu',
    'ws_emr_nursing_notes': 'Nursing notes',
    'ws_emr_orders': 'Orders',
    'ws_emr_overview': 'Summary',
    'ws_emr_progress_notes': 'Progress notes',
    'ws_full_record_hint': 'Every visit, admission and result of this patient',
    'ws_group_discharge': 'Discharge',
    'ws_group_documents': 'Documents',
    'ws_group_insurance': 'Insurance',
    'ws_group_money': 'Money',
    'ws_group_overview': 'Overview',
    'ws_group_stay': 'Stay',
    'ws_hand_over': 'Hand over',
    'ws_how_the_stay_ended': 'How the stay ended',
    'ws_imaging': 'Imaging',
    'ws_interim_claim_detail': '{count, plural, one {# bill} other {# bills}} from {from} to {to}',
    'ws_investigations_desc': 'Lab tests and imaging for this stay',
    'ws_investigations_open_x': '{lab} lab and {imaging} imaging not yet released',
    'ws_keep_x_as_co_consultant': 'Keep {name} on the team as a co-consultant',
    'ws_lab_tests': 'Lab tests',
    'ws_latest_approval': 'Latest approval',
    'ws_latest_vitals': 'Latest vitals',
    'ws_left_on_x': 'Left on {date}',
    'ws_marker_done': 'Done',
    'ws_marker_required': 'Required',
    'ws_member_removed': 'Taken off the care team',
    'ws_menu': 'Admission menu',
    'ws_more_actions': 'More',
    'ws_nav_advances': 'Advances',
    'ws_nav_bed': 'Bed and transfers',
    'ws_nav_bill': 'Running bill',
    'ws_nav_care_team': 'Care team',
    'ws_nav_daily_charges': 'Daily charges',
    'ws_nav_discharge': 'Discharge',
    'ws_nav_documents': 'Documents and prints',
    'ws_nav_dues': 'Dues and follow-up',
    'ws_nav_overview': 'Summary',
    'ws_nav_packages': 'Package',
    'ws_nav_preauth': 'Pre-authorisation',
    'ws_new_primary_consultant': 'New primary consultant',
    'ws_no_active_orders': 'No active orders',
    'ws_no_bed': 'No bed',
    'ws_no_care_team': 'Nobody is on the care team yet',
    'ws_no_doses_due': 'No doses are due',
    'ws_no_known_allergies': 'No known allergies',
    'ws_no_package': 'No package on this stay',
    'ws_no_transfers': 'No bed moves yet',
    'ws_nothing_billed_yet': 'Nothing has been billed yet',
    'ws_nothing_owing': 'Nothing is owing on this stay',
    'ws_nurses_come_from_the_ward_roster': 'Nurses are not listed here; they come from the ward roster',
    'ws_nursing_notes_desc': 'Shift notes, handovers, care plans and incidents',
    'ws_open': 'Open',
    'ws_open_care_team': 'Open the care team',
    'ws_open_ipd_emr': 'Open IPD EMR',
    'ws_open_work': 'Open work',
    'ws_owing_x': '{amount} owing',
    'ws_packages_desc': 'An inpatient package bought for this stay and what it has covered',
    'ws_paid': 'Paid',
    'ws_past_members': 'Earlier on the team',
    'ws_payer': 'Payer',
    'ws_preauth_approved': 'Approved',
    'ws_preauth_needed': 'Needed',
    'ws_preauth_not_required': 'Not required',
    'ws_preauth_pending': 'Waiting',
    'ws_preauth_self_pay': 'Self-pay',
    'ws_preauth_self_pay_desc': 'The patient pays; no pre-authorisation is needed',
    'ws_preauth_status': 'Pre-authorisation status',
    'ws_preauth_unknown': 'Checking',
    'ws_print_final_bill': 'Print final bill',
    'ws_print_interim_bill': 'Print interim bill',
    'ws_prints': 'Prints',
    'ws_progress_notes_desc': 'Doctor notes in SOAP form',
    'ws_promised_x': 'promised {date}',
    'ws_record_follow_up': 'Record follow-up',
    'ws_remove': 'Remove',
    'ws_remove_from_care_team': 'Take off the care team?',
    'ws_remove_from_care_team_desc': '{name} will no longer be on this admission. The record of when they served is kept.',
    'ws_requests_waiting': 'Requests waiting',
    'ws_respiratory_rate': 'Resp. rate',
    'ws_role': 'Role',
    'ws_role_co_consultant': 'Co-consultant',
    'ws_role_primary_consultant': 'Primary consultant',
    'ws_role_resident': 'Resident / medical officer',
    'ws_role_short_co_consultant': 'Co',
    'ws_role_short_primary_consultant': 'Primary',
    'ws_role_short_resident': 'Resident',
    'ws_room_bed': 'Room and bed',
    'ws_see_pre_authorisation': 'See pre-authorisation',
    'ws_self_pay': 'Self-pay',
    'ws_served_from_x_to_x': '{from} to {to}',
    'ws_shift_x': '{shift} shift',
    'ws_signed_summary': 'Signed summary',
    'ws_statement_hint': 'Bills, payments and advances in one statement',
    'ws_stay': 'Stay',
    'ws_summary_print_hint': 'The signed discharge summary',
    'ws_summary_written_at_discharge_desc': 'The discharge summary is written and signed on the discharge form.',
    'ws_taken_at_x': 'Taken {time}',
    'ws_transfer_history': 'Bed moves',
    'ws_unknown_doctor': 'Unknown doctor',
    'ws_used_x_of_x': '{used} used of {price}',
    'ws_vitals_desc': 'Readings recorded on this stay, newest first',
    'ws_ward': 'Ward',
    'ws_ward_workspace': 'Ward workspace',
    'ws_written_at_discharge': 'Written at discharge',
    'admission_priority': 'Admission priority',
    'admission_priority_hint': 'Sent to the insurer with the pre-authorisation for the stay',
    'priority_elective': 'Elective',
    'priority_urgent': 'Urgent',
    'priority_emergency': 'Emergency',
    'intended_stay': 'Expected stay',
    'intended_stay_hint': 'Sent to the insurer as the intended length of stay',
    'intended_stay_ISD': 'Same day',
    'intended_stay_IO': 'Overnight',
    'admitting_specialty': 'Admitting specialty',
    'admitting_specialty_hint': 'Its NPHIES practice code goes to the insurer',
    'specialty_none': 'No specialty',
    'specialty_no_code': '{name} (no NPHIES code)',
    'discharge_disposition': 'Where the patient went',
    'discharge_disposition_hint': 'Sent to the insurer as the discharge disposition',
    'discharge_disposition_home': 'Home',
    'discharge_disposition_LAMA': 'Left against medical advice',
    'discharge_disposition_died': 'Died',
    'discharge_disposition_acute-hospital': 'Another acute hospital',
    'discharge_disposition_DTPH': 'Psychiatric hospital',
    'discharge_disposition_DTRAS': 'Residential aged care',
    'discharge_disposition_DTOHA': 'Other healthcare accommodation',
    'discharge_disposition_SDTC': 'Statistical discharge, care type change',
    'discharge_disposition_SDFL': 'Statistical discharge from leave',
    'discharge_disposition_in-hospital': 'Still in hospital',
    'discharge_specialty': 'Discharge specialty',
    'discharge_specialty_hint': 'The specialty in charge when the patient left',
    'cause_of_death_code': 'Cause of death as an ICD-10 code',
    'cause_of_death_code_hint': 'The insurer needs it on the claim when the patient died',
    'change_the_cause_of_death': 'Change the cause of death',
    'insurer_discharge_details': 'Discharge details for the insurer',
    'insurer_discharge_details_desc': 'Sent with the inpatient claim',
    'insurer_details_saved': 'Saved',
    'could_not_save_the_insurer_details': 'Could not save the details',
    'select': 'Select…',
    'advance_deposit': 'Advance deposit',
    'collected_at_the_admission_desk': 'Collected at the admission desk',
    'provisional_diagnosis': 'Provisional diagnosis',
    'bed_board': 'Bed board',
    'who_is_where_and_what_they_owe': 'Who is where, and what they owe',
    'all_wards': 'All wards',
    'occupied': 'Occupied',
    'vacant': 'Vacant',
    'owes_x': 'Owes {amount}',
    'credit_x': 'Credit {amount}',
    'could_not_load_the_bed_board': 'Could not load the bed board.',
    'try_again': 'Try again',
    'no_beds_to_show': 'No beds to show',
    'beds_are_added_under_wards_and_rooms_in_administration': 'Beds are added under wards and rooms in administration.',
    'since': '· since',
    'bed_updated': 'Bed updated',
    'bed_x': 'Bed {bedCode}',
    'move_the_bed_between_housekeeping_states': 'Move the bed between housekeeping states',
    'update_bed': 'Update bed',
    'housekeeping_may_not_have_finished_this_bed': 'Housekeeping may not have finished this bed. Releasing it early needs housekeeping authority and a reason, which goes in the audit trail.',
    'optional_kept_with_the_bed_for_example_why_it': 'Optional. Kept with the bed, for example why it is blocked.',
    'a_bed_becomes_occupied_by_admitting_or': 'A bed becomes occupied by admitting or transferring a patient into it, never by hand.',
    'your_role_cannot_change_bed_status': 'Your role cannot change bed status.',
    'bed_board_live': 'Live',
    'bed_board_live_hint': 'Admissions, transfers and housekeeping show up here as they happen.',
    'bed_board_polling': 'Refreshing every minute',
    'bed_board_polling_hint': 'The live connection is down, so the board checks for changes once a minute.',
    'updated_x': 'Updated {time}',
    'refresh_the_board': 'Refresh the board',
    'occupancy': 'Occupancy',
    'x_of_y_beds_occupied': '{occupied} of {total} beds occupied',
    'x_pct_of_beds': '{value}% of beds',
    'expected_discharges_today': 'Expected discharges today',
    'x_tomorrow': 'Tomorrow: {count}',
    'show_only_these_beds': 'Show only these beds',
    'wards': 'Wards',
    'ward_occupancy_x': '{ward}: {occupied} of {total} beds occupied',
    'filters': 'Filters',
    'all_statuses': 'All statuses',
    'discharging_today': 'Discharging today',
    'patient_sex': 'Patient sex',
    'any_sex': 'Any',
    'search_the_board': 'Search the board',
    'name_mrn_or_bed': 'Name, MRN or bed',
    'clear_filters': 'Clear filters',
    'show_x_beds': '{count, plural, one {Show # bed} other {Show # beds}}',
    'legend': 'Legend',
    'room_x': 'Room {code}',
    'x_of_y_occupied': '{occupied} of {total} occupied',
    'day_x': 'Day {count}',
    'admitted_x': 'Admitted {when}',
    'attending_doctor': 'Attending doctor',
    'available': 'Available',
    'ready_for_a_patient': 'Ready for a patient',
    'cleaning_started_x': 'Cleaning started {when}',
    'reserved_x': 'Reserved {when}',
    'blocked_x': 'Blocked {when}',
    'x_allergies_recorded': '{count, plural, one {# allergy recorded} other {# allergies recorded}}',
    'covered_by_x': 'Covered by {payer}',
    'discharge_expected_today': 'Discharge expected today',
    'discharge_expected_tomorrow': 'Discharge expected tomorrow',
    'past_expected_discharge_x': 'Past the expected discharge date, {date}',
    'age_days_short': '{count} d',
    'age_months_short': '{count} mo',
    'age_years_short': '{count} y',
    'open_admission': 'Open admission',
    'admit_a_patient_here': 'Admit a patient here',
    'choose_bed_x_on_the_admission_form': 'Choose bed {bedCode} on the admission form',
    'mark_cleaned_and_available': 'Mark cleaned and available',
    'open_housekeeping': 'Open housekeeping',
    'reserve_bed': 'Reserve',
    'send_to_cleaning': 'Send to cleaning',
    'block_bed': 'Block',
    'unblock_bed': 'Unblock',
    'release_reservation': 'Release reservation',
    'change_status': 'Change status…',
    'nothing_here_your_role_can_change': 'Nothing here your role can change',
    'no_free_beds_to_move_to': 'No free beds to move to',
    'add_a_ward': 'Add a ward',
    'no_beds_match_these_filters': 'No beds match these filters',
    'try_another_ward_or_clear_the_filters': 'Try another ward, or clear the filters.',
    'bed_class_general': 'General',
    'bed_class_semi_private': 'Semi-private',
    'bed_class_private': 'Private',
    'bed_class_deluxe': 'Deluxe',
    'bed_class_icu': 'ICU',
    'bed_class_ccu': 'CCU',
    'bed_class_nicu': 'NICU',
    'bed_class_hdu': 'HDU',
    'bed_class_isolation': 'Isolation',
    'mrn': 'MRN',
    'phone': 'Phone',
    'closed_on': 'Closed on',
    'age_days': 'Age (days)',
    'age_bucket': 'Age bucket',
    'paid': 'Paid',
    'advance_held': 'Advance held',
    'advance_kept_after_absconding': 'Advance kept after absconding',
    'last_follow_up': 'Last follow-up',
    'promised_date': 'Promised date',
    'the_register_could_not_be_exported': 'The register could not be exported',
    'dues_register': 'Dues register',
    'patients_who_have_left_and_still_owe_money_with': 'Patients who have left and still owe money, with how long it has been and what was said to them.',
    'export_to_spreadsheet': 'Export to spreadsheet',
    'owed_in_total': 'Owed in total',
    'x_admission_s': '{totalAdmissions} admission(s)',
    'x_days': '{bucket} days',
    'x_admission_s_2': '{admissions} admission(s)',
    'advances_kept': 'Advances kept',
    'x_patient_s_left_not_refunded': '{advanceHeldAdmissions} patient(s) left; not refunded',
    'every_outcome': 'Every outcome',
    'any_age': 'Any age',
    'days': 'days',
    'search_name_mrn_phone_or_admission': 'Search name, MRN, phone or admission',
    'nobody_who_has_left_owes_anything_and_no': 'Nobody who has left owes anything, and no advance is being kept, in this period.',
    'no_phone': 'no phone',
    'left': 'Left',
    'age': 'Age',
    'of': 'of',
    'advance_kept': 'Advance kept',
    'follow_up': 'Follow-up',
    'promised': 'Promised',
    'nobody_has_followed_up': 'nobody has followed up',
    'follow_up_2': 'Follow up',
    'bill_2': 'Bill',
    'show_more': 'Show more',
    'follow_up_recorded': 'Follow-up recorded',
    'x_owes_x': '{fullName} — owes {dueMinor}',
    'x_left_x_x_days_ago': '{number} · left {dischargedAt} · {ageDays} days ago',
    'close': 'Close',
    'the_patient_left_without_notice_with': 'The patient left without notice with',
    'of_advance_unused_it_has_not_been_refunded_it': 'of advance unused. It has not been refunded; it stays as an advance held until someone decides what to do with it.',
    'nobody_has_followed_up_on_this_yet': 'Nobody has followed up on this yet.',
    'someone': 'Someone',
    'what_happened': 'What happened',
    'called_the_brother_he_will_pay_half_on_friday': 'Called the brother; he will pay half on Friday',
    'promised_amount': 'Promised amount',
    'record_follow_up': 'Record follow-up',
    'mortality_figures_are_not_part_of_your_role': 'Mortality figures are not part of your role.',
    'loading': 'Loading…',
    'the_mortality_report_could_not_be_loaded': 'The mortality report could not be loaded.',
    'deaths': 'Deaths',
    'wards_and_emergency_in_this_period': 'Wards and emergency, in this period',
    'admissions_closed': 'Admissions closed',
    'discharged_lama_referred_absconded_or_expired': 'Discharged, LAMA, referred, absconded or expired',
    'ward_mortality': 'Ward mortality',
    'ward_deaths_over_admissions_closed': 'Ward deaths over admissions closed',
    'by_ward': 'By ward',
    'no_deaths_in_this_period': 'No deaths in this period.',
    'by_cause': 'By cause',
    'cause': 'Cause',
    'each_death': 'Each death',
    'when': 'When',
    'where': 'Where',
    'mlc': 'MLC',
    'showing_the_latest_500_narrow_the_dates_to_see': 'Showing the latest 500. Narrow the dates to see the rest.',
    'find_a_patient': 'Find a patient',
    'where_an_admitted_patient_is_for_visitors_ward': 'Where an admitted patient is, for visitors. Ward, room and bed only.',
    'patient_name': 'Patient name',
    'no_admitted_patient_matches_that_name': 'No admitted patient matches that name.',
    'room': 'Room',
    'type_at_least': 'Type at least',
    'letters_of_the_patients_name': 'letters of the patient\'s name.',
    'charge_resumed': 'Charge resumed',
    'it_is_posted_again_from_today': 'It is posted again from today',
    'could_not_resume_the_charge': 'Could not resume the charge',
    'recurring_daily_charges': 'Recurring daily charges',
    'the_hospital_has_no_recurring_ward_charges_set': 'The hospital has no recurring ward charges set up.',
    'charge': 'Charge',
    'a_day': 'a day ·',
    'every_patient': 'every patient',
    'for_this_patient': 'For this patient',
    'paused': 'paused',
    'charged_daily': 'charged daily',
    'pause_for_this_patient': 'Pause for this patient',
    'pauses_on_this_admission': 'Pauses on this admission',
    'no_charge_has_been_paused_for_this_patient': 'No charge has been paused for this patient.',
    'from': 'From',
    'until': 'Until',
    'why': 'Why',
    'resume': 'Resume',
    'charge_paused': 'Charge paused',
    'x_is_not_posted_for_this_patient_until_it_is': '{name} is not posted for this patient until it is resumed',
    'pause_x': 'Pause {name}',
    'days_already_posted_stay_on_the_bill_use_the': 'Days already posted stay on the bill. Use the bill to remove a line charged in error.',
    'pause': 'Pause',
    'patient_is_in_theatre_no_visit_charge_today': 'Patient is in theatre; no visit charge today',
    'leave_blank_to_pause_until_someone_resumes_it': 'Leave blank to pause until someone resumes it',
    'rule_retired': 'Rule retired',
    'charges_already_posted_stay_on_the_bills': 'Charges already posted stay on the bills',
    'could_not_retire_the_rule': 'Could not retire the rule',
    'ward_charges': 'Ward charges',
    'charges_the_system_adds_to_every_admitted': 'Charges the system adds to every admitted patient each day, such as the consultant visit or nursing care. They are posted overnight to the running bill, once per patient per day.',
    'add_a_rule': 'Add a rule',
    'no_recurring_charges_yet_add_a_rule_for_the': 'No recurring charges yet. Add a rule for the daily doctor visit or nursing care.',
    'rule': 'Rule',
    'applies_to': 'Applies to',
    'how_often': 'How often',
    'doctor': 'Doctor',
    'price': 'Price',
    'active': 'active',
    'off': 'off',
    'edit': 'Edit',
    'retire': 'Retire',
    'rule_saved': 'Rule saved',
    'rule_added': 'Rule added',
    'it_starts_from_today_earlier_days_of_a_stay_are': 'It starts from today; earlier days of a stay are not charged.',
    'edit_ward_charge_rule': 'Edit ward charge rule',
    'add_a_ward_charge_rule': 'Add a ward charge rule',
    'save_rule': 'Save rule',
    'name': 'Name',
    'shown_on_the_bill_followed_by_the_date': 'Shown on the bill, followed by the date',
    'daily_consultant_visit': 'Daily consultant visit',
    'leave_blank_for_every_ward': 'Leave blank for every ward',
    'every_ward': 'Every ward',
    'leave_blank_for_every_class': 'Leave blank for every class',
    'every_class': 'Every class',
    'charge_item': 'Charge item',
    'search_the_charge_master': 'Search the charge master',
    'search_by_name_or_code': 'Search by name or code',
    'credit_this_charge_to_the_admitting_doctor': 'Credit this charge to the admitting doctor (counts in doctor payouts)',
    'credit_this_charge_to_the_admitting_doctor_2': 'Credit this charge to the admitting doctor',
    'active_2': 'Active',
    'x_nurse_station_phone_saved': '{name}: nurse-station phone saved',
    'critical_results_for_patients_on_this_ward_are': 'Critical results for patients on this ward are paged here when their doctors have no phone on file',
    'could_not_save_the_phone': 'Could not save the phone',
    'nurse_station_x': 'Nurse station {nurseStationPhone}',
    'add_nurse_station_phone': 'Add nurse-station phone',
    'nurse_station_phone': 'Nurse-station phone',
    'save': 'Save',
    'period': 'Period',
    'io_kind_medication': 'Medication',
    'io_kind_iv_fluid': 'IV fluid',
    'io_kind_diet': 'Diet',
    'io_kind_nursing': 'Nursing care',
    'io_kind_procedure': 'Procedure',
    'io_kind_lab': 'Lab test',
    'io_kind_radiology': 'Imaging',
    'io_kind_blood_transfusion': 'Blood transfusion',
    'io_kind_oxygen': 'Oxygen',
    'io_kind_physiotherapy': 'Physiotherapy',
    'io_kind_consult': 'Consult',
    'io_kind_vitals_monitoring': 'Vitals monitoring',
    'io_priority_routine': 'Routine',
    'io_priority_urgent': 'Urgent',
    'io_priority_stat': 'Stat (now)',
    'io_state_active': 'Active',
    'io_state_held': 'On hold',
    'io_state_stopped': 'Stopped',
    'io_state_completed': 'Completed',
    'io_status_upcoming': 'Upcoming',
    'io_status_due': 'Due now',
    'io_status_overdue': 'Overdue',
    'io_status_missed': 'Missed',
    'io_status_given': 'Given',
    'io_status_given_late': 'Given late',
    'io_status_held': 'Held',
    'io_status_refused': 'Refused',
    'io_status_not_given': 'Not given',
    'io_outcome_given': 'Given',
    'io_outcome_done': 'Done',
    'io_outcome_held': 'Held',
    'io_outcome_refused': 'Refused',
    'io_outcome_not_given': 'Not given',
    'io_outcome_not_done': 'Not done',
    'io_outcome_missed': 'Missed',
    'io_reason_patient_refused': 'Patient refused',
    'io_reason_family_refused': 'Family refused',
    'io_reason_patient_npo': 'Nil by mouth',
    'io_reason_patient_away': 'Patient away from the ward',
    'io_reason_patient_asleep': 'Patient asleep',
    'io_reason_vomiting': 'Vomiting',
    'io_reason_clinical_hold': 'Held on clinical grounds',
    'io_reason_vitals_out_of_range': 'Vitals out of range',
    'io_reason_result_awaited': 'Waiting for a result',
    'io_reason_doctor_order': 'Doctor asked to wait',
    'io_reason_drug_unavailable': 'Medicine not available',
    'io_reason_iv_access_lost': 'IV access lost',
    'io_reason_equipment_unavailable': 'Equipment not available',
    'io_reason_workload': 'Ward workload',
    'io_reason_late_documentation': 'Done on time, recorded late',
    'io_reason_not_documented': 'Not documented',
    'io_reason_procedure': 'Procedure planned',
    'io_reason_other': 'Other',
    'io_task_kind_dose': 'Dose',
    'io_task_kind_iv_start': 'Start drip',
    'io_task_kind_iv_check': 'Drip check',
    'io_task_kind_iv_end': 'End drip',
    'io_task_kind_meal': 'Meal',
    'io_task_kind_nursing': 'Nursing task',
    'io_task_kind_vitals_round': 'Vitals round',
    'io_task_kind_transfusion_check': 'Transfusion check',
    'io_task_kind_o2_check': 'Oxygen check',
    'io_task_kind_physio': 'Physiotherapy session',
    'io_task_kind_consult_due': 'Consult due',
    'io_task_kind_procedure_due': 'Procedure due',
    'io_task_kind_collect': 'Sample collection',
    'io_set_title': 'Inpatient schedules',
    'io_set_desc': 'When ward tasks fall due. Changes apply to tasks planned from now on; tasks already on the chart keep their times.',
    'io_set_dose_times': 'Dose times',
    'io_set_dose_times_hint': 'The clock times each frequency is given at',
    'io_set_freq_od': 'OD - once a day',
    'io_set_freq_bd': 'BD - twice a day',
    'io_set_freq_tds': 'TDS - three times a day',
    'io_set_freq_qds': 'QDS - four times a day',
    'io_set_freq_hs': 'HS - at bedtime',
    'io_set_freq_q4h': 'Every 4 hours',
    'io_set_freq_q6h': 'Every 6 hours',
    'io_set_freq_q8h': 'Every 8 hours',
    'io_set_freq_q12h': 'Every 12 hours',
    'io_set_freq_q24h': 'Every 24 hours',
    'io_set_times_a_day': 'Times a day: {count}',
    'io_set_needs_times': 'Needs {count} times, has {actual}; not saved yet',
    'io_set_add_time': 'Add time',
    'io_set_remove_time': 'Remove {time}',
    'io_set_time_taken': 'That time is already on the list',
    'io_set_reset': 'Use the default',
    'io_set_meal_times': 'Meal times',
    'io_set_meal_times_hint': 'Up to six; the first three are breakfast, lunch and dinner',
    'io_set_meal_breakfast': 'breakfast',
    'io_set_meal_lunch': 'lunch',
    'io_set_meal_dinner': 'dinner',
    'io_set_vitals': 'Vitals rounds',
    'io_set_vitals_hint': 'How often a new admission is put on vitals rounds; a ward can differ from the hospital',
    'io_set_vitals_hospital': 'Whole hospital',
    'io_set_wards': 'By ward',
    'io_set_ward_default': 'Hospital default',
    'io_set_no_wards': 'No wards to show',
    'io_set_wards_unavailable': 'The ward list is not open to you; ask someone who manages beds',
    'io_set_off': 'Off',
    'io_set_hours': '{hours} h',
    'io_set_minutes': '{minutes} min',
    'io_set_overdue': 'Overdue tasks',
    'io_set_overdue_label': 'Alert the nurses on duty and the care team when a task is still not done',
    'io_set_overdue_hint': 'Minutes after the task became overdue. One alert per patient; stat orders and high-alert medicines alert as critical.',
    'io_set_saved': 'Inpatient schedule saved',
    'io_set_could_not_save': 'Could not save the inpatient schedule',
    'io_ord_task_chart': 'Task chart',
    'io_ord_section_procedures': 'Procedures',
    'io_ord_section_oxygen': 'Oxygen therapy',
    'io_ord_section_transfusion': 'Blood transfusion',
    'io_ord_section_physiotherapy': 'Physiotherapy',
    'io_ord_section_consults': 'Consults',
    'io_ord_section_monitoring': 'Vitals monitoring',
    'io_ord_desc_procedures': 'Procedures for this stay, done here and billed to the stay',
    'io_ord_desc_oxygen': 'Oxygen orders with the device, flow and target saturation',
    'io_ord_desc_transfusion': 'Blood product orders and their transfusion checks',
    'io_ord_desc_physiotherapy': 'Physiotherapy sessions ordered for this stay',
    'io_ord_desc_consults': 'Opinions asked from other doctors and departments',
    'io_ord_desc_monitoring': 'How often the ward takes the vital signs',
    'io_ord_orders_desc': 'Every order of this stay; doses and ward tasks follow from them',
    'io_ord_new_oxygen': 'New oxygen order',
    'io_ord_new_blood_transfusion': 'New transfusion order',
    'io_ord_new_physiotherapy': 'New physiotherapy order',
    'io_ord_new_consult': 'New consult request',
    'io_ord_new_vitals_monitoring': 'New monitoring order',
    'io_ord_tab_running': 'Active',
    'io_ord_tab_held': 'On hold',
    'io_ord_tab_stopped': 'Stopped',
    'io_ord_tabs_label': 'Which orders to show',
    'io_ord_filter_all': 'All kinds',
    'io_ord_filter_label': 'Filter by kind',
    'io_ord_col_order': 'Order',
    'io_ord_col_state': 'State',
    'io_ord_col_when': 'Start and end',
    'io_ord_col_next': 'Next task',
    'io_ord_col_hold': 'Why it is on hold',
    'io_ord_col_stop': 'Why it stopped',
    'io_ord_until_x': 'Until {time}',
    'io_ord_no_end': 'No end set',
    'io_ord_no_next_task': 'No task scheduled',
    'io_ord_stopped_at_x': 'Stopped on {time}',
    'io_ord_held_at_x': 'On hold since {time}',
    'io_ord_high_alert': 'High alert',
    'io_ord_empty_held': 'No orders on hold',
    'io_ord_empty_stopped': 'No stopped orders',
    'io_ord_load_more': 'Load more',
    'io_ord_stop': 'Stop',
    'io_ord_hold': 'Hold',
    'io_ord_resume': 'Resume',
    'io_ord_extra_dose': 'Extra dose',
    'io_ord_prn_dose': 'Give a dose',
    'io_ord_stop_title_x': 'Stop {label}?',
    'io_ord_stop_desc': 'Its pending tasks from now on are removed. A stopped order is not restarted; order it again if it is needed.',
    'io_ord_stopped_toast': 'Order stopped',
    'io_ord_stop_desc_investigation': 'Its pending tasks are removed, and tests not yet collected, imaging not yet arrived and procedures not yet done are cancelled with this reason. Work that has started stays.',
    'io_ord_stop_cancelled_x': '{count, plural, one {# line was cancelled.} other {# lines were cancelled.}}',
    'io_ord_stop_kept_x': 'Already started, so it stays: {lines}.',
    'io_ord_stop_refund': 'Some cancelled work was already paid for; arrange the refund at billing.',
    'io_ord_could_not_stop': 'Could not stop the order',
    'io_ord_hold_title_x': 'Put {label} on hold?',
    'io_ord_hold_desc': 'Its pending tasks from now on are removed until the order is resumed.',
    'io_ord_hold_reason_code': 'Why it is held',
    'io_ord_held_toast': 'Order on hold',
    'io_ord_could_not_hold': 'Could not put the order on hold',
    'io_ord_resume_title_x': 'Resume {label}?',
    'io_ord_resume_desc': 'Tasks are scheduled again from now.',
    'io_ord_resumed_toast': 'Order resumed',
    'io_ord_could_not_resume': 'Could not resume the order',
    'io_ord_dose_title_x': 'Extra dose of {label}',
    'io_ord_dose_desc': 'Record a dose given outside the schedule',
    'io_ord_dose_in_future': 'The time cannot be in the future',
    'io_ord_dose_reason': 'Why it is given',
    'io_ord_reason_min': 'At least {min} characters',
    'io_ord_dose_given': 'Dose given',
    'io_ord_witness_required': 'Choose the second nurse who witnessed the dose',
    'io_ord_kind_switch': 'What to order',
    'io_ord_reorder_cancel': 'Do not re-order',
    'io_ord_reorder_unavailable': 'This kind of order is switched off for inpatients',
    'io_ord_route_oral': 'Oral',
    'io_ord_route_iv': 'Intravenous',
    'io_ord_route_im': 'Intramuscular',
    'io_ord_route_sc': 'Subcutaneous',
    'io_ord_route_sl': 'Sublingual',
    'io_ord_route_buccal': 'Buccal',
    'io_ord_route_inhaled': 'Inhaled',
    'io_ord_route_nebulised': 'Nebulised',
    'io_ord_route_topical': 'On the skin',
    'io_ord_route_transdermal': 'Skin patch',
    'io_ord_route_pr': 'Rectal',
    'io_ord_route_pv': 'Vaginal',
    'io_ord_route_ng': 'Nasogastric tube',
    'io_ord_route_peg': 'PEG tube',
    'io_ord_route_ophthalmic': 'Into the eye',
    'io_ord_route_otic': 'Into the ear',
    'io_ord_route_nasal': 'Nasal',
    'io_ord_route_intradermal': 'Intradermal',
    'io_ord_route_epidural': 'Epidural',
    'io_ord_route_intrathecal': 'Intrathecal',
    'io_ord_route_other': 'Other route',
    'io_ord_freq_once': 'Once',
    'io_ord_freq_stat': 'Once, now',
    'io_ord_prn': 'As needed',
    'io_ord_prn_max_x': 'Up to {count} a day',
    'io_ord_every_hours': 'Every {count} h',
    'io_ord_every_minutes': 'Every {count} min',
    'io_ord_over_hours': 'Over {count} h',
    'io_ord_over_minutes': 'Over {count} min',
    'io_ord_unit_over_hours': 'Each unit over {count} h',
    'io_ord_unit_over_minutes': 'Each unit over {count} min',
    'io_ord_days_x': 'Days: {count}',
    'io_ord_rate_x': 'At {rate} ml/h',
    'io_ord_continuous': 'Continuous',
    'io_ord_bags_x': 'Bags: {count}',
    'io_ord_additives_x': 'Additives: {count}',
    'io_ord_diet_normal': 'Normal diet',
    'io_ord_diet_diabetic': 'Diabetic diet',
    'io_ord_diet_renal': 'Renal diet',
    'io_ord_diet_cardiac': 'Cardiac diet',
    'io_ord_diet_soft': 'Soft diet',
    'io_ord_diet_liquid': 'Liquid diet',
    'io_ord_diet_npo': 'Nil by mouth',
    'io_ord_diet_high_protein': 'High protein diet',
    'io_ord_diet_low_salt': 'Low salt diet',
    'io_ord_texture_soft': 'Soft texture',
    'io_ord_texture_minced': 'Minced',
    'io_ord_texture_pureed': 'Pureed',
    'io_ord_texture_liquid': 'Liquid texture',
    'io_ord_fluid_limit_x': 'Fluids up to {ml} ml a day',
    'io_ord_npo_until_x': 'Nil by mouth until {time}',
    'io_ord_npo_from_x': 'Nil by mouth from {time}',
    'io_ord_planned_x': 'Planned for {time}',
    'io_ord_collect_x': 'Collect at {time}',
    'io_ord_fasting': 'Fasting',
    'io_ord_product_whole_blood': 'Whole blood',
    'io_ord_product_packed_red_cells': 'Packed red cells',
    'io_ord_product_fresh_frozen_plasma': 'Fresh frozen plasma',
    'io_ord_product_platelets': 'Platelets',
    'io_ord_product_cryoprecipitate': 'Cryoprecipitate',
    'io_ord_units_x': 'Units: {count}',
    'io_ord_device_nasal_cannula': 'Nasal cannula',
    'io_ord_device_simple_mask': 'Simple face mask',
    'io_ord_device_venturi_mask': 'Venturi mask',
    'io_ord_device_non_rebreather': 'Non-rebreather mask',
    'io_ord_device_high_flow_nasal': 'High-flow nasal oxygen',
    'io_ord_device_cpap': 'CPAP',
    'io_ord_device_bipap': 'BiPAP',
    'io_ord_device_ventilator': 'Ventilator',
    'io_ord_target_spo2_x': 'Target SpO2 {min} to {max}%',
    'io_ord_physio_chest': 'Chest physiotherapy',
    'io_ord_physio_mobilisation': 'Mobilisation',
    'io_ord_physio_limb_exercises': 'Limb exercises',
    'io_ord_physio_gait_training': 'Gait training',
    'io_ord_physio_positioning': 'Positioning',
    'io_ord_physio_other': 'Other physiotherapy',
    'io_ord_sessions_x': 'Sessions a day: {count}',
    'io_ord_urgency_emergency': 'Emergency',
    'io_ord_param_bp': 'Blood pressure',
    'io_ord_param_pulse': 'Pulse',
    'io_ord_param_respiratory_rate': 'Breathing rate',
    'io_ord_param_temperature': 'Temperature',
    'io_ord_param_spo2': 'Oxygen saturation',
    'io_ord_param_pain': 'Pain score',
    'io_ord_param_blood_sugar': 'Blood sugar',
    'io_ord_param_consciousness': 'Consciousness',
    'io_task_chart_title': 'Task chart',
    'io_task_chart_desc': 'Every ward task of this stay, hour by hour. Tap a task to record it or to see what was recorded.',
    'io_task_chart_range': '{from} to {to}',
    'io_task_chart_empty': 'No ward tasks in these 24 hours',
    'io_task_previous_day': 'Previous 24 hours',
    'io_task_next_day': 'Next 24 hours',
    'io_task_now': 'Now',
    'io_task_order': 'Order',
    'io_task_chip_label': '{task} at {time}: {status}',
    'io_task_dialog_desc': '{task}, due {time}',
    'io_task_high_alert': 'High alert',
    'io_task_bag': 'Bag {bag}',
    'io_task_unit_step': 'Unit {unit}: {step}',
    'io_task_step_pre_vitals': 'Vitals before',
    'io_task_step_start': 'Start',
    'io_task_step_check_15': '15-minute check',
    'io_task_step_check': 'Hourly check',
    'io_task_step_end': 'End',
    'io_task_step_post_vitals': 'Vitals after',
    'io_task_initial': 'First check',
    'io_task_meal_breakfast': 'Breakfast',
    'io_task_meal_lunch': 'Lunch',
    'io_task_meal_dinner': 'Dinner',
    'io_task_meal_n': 'Meal {number}',
    'io_task_given_at': 'Given at',
    'io_task_done_at': 'Done at',
    'io_task_time': 'Time',
    'io_task_reason': 'Reason',
    'io_task_late_reason': 'Why it was late (optional)',
    'io_task_late_hint': 'This is after the grace window, so it is charted as done late.',
    'io_task_early_reason': 'Why it is given now',
    'io_task_early_hint': 'This dose is more than an hour early; say why it is given now.',
    'io_task_other_reason': 'Describe the reason',
    'io_task_missed_hint': 'Records that the task was not done in time. Choose why.',
    'io_task_dose_given': 'Dose given',
    'io_task_dose_given_hint': 'Leave it empty when the ordered dose was given.',
    'io_task_readings': 'Readings',
    'io_task_reading_bp_systolic': 'Systolic BP (mmHg)',
    'io_task_reading_bp_diastolic': 'Diastolic BP (mmHg)',
    'io_task_reading_pulse': 'Pulse (per min)',
    'io_task_reading_respiratory_rate': 'Breaths (per min)',
    'io_task_reading_temperature': 'Temperature (°C)',
    'io_task_reading_spo2': 'SpO2 (%)',
    'io_task_reading_pain': 'Pain (0 to 10)',
    'io_task_reading_blood_sugar': 'Blood sugar (mg/dL)',
    'io_task_reading_consciousness': 'Consciousness (AVPU)',
    'io_task_reading_flow': 'Oxygen flow (L/min)',
    'io_task_reading_fio2': 'FiO2 (%)',
    'io_task_reading_device': 'Oxygen device',
    'io_task_reading_rate': 'Drip rate (ml/h)',
    'io_task_reading_volume': 'Volume infused (ml)',
    'io_task_reading_site': 'Drip site',
    'io_task_reading_reaction': 'Transfusion reaction',
    'io_task_reading_reaction_notes': 'What happened',
    'io_task_reaction_seen': 'Reaction seen',
    'io_task_reaction_none': 'No reaction',
    'io_task_avpu_alert': 'Alert',
    'io_task_avpu_voice': 'Voice',
    'io_task_avpu_pain': 'Pain',
    'io_task_avpu_unresponsive': 'Unresponsive',
    'io_task_site_ok': 'Looks fine',
    'io_task_site_redness': 'Redness',
    'io_task_site_swelling': 'Swelling',
    'io_task_site_pain': 'Painful',
    'io_task_site_leaking': 'Leaking',
    'io_task_site_infiltrated': 'Infiltrated',
    'io_task_site_phlebitis': 'Phlebitis',
    'io_task_device_nasal_cannula': 'Nasal cannula',
    'io_task_device_simple_mask': 'Simple mask',
    'io_task_device_venturi_mask': 'Venturi mask',
    'io_task_device_non_rebreather': 'Non-rebreather mask',
    'io_task_device_high_flow_nasal': 'High-flow nasal',
    'io_task_device_cpap': 'CPAP',
    'io_task_device_bipap': 'BiPAP',
    'io_task_device_ventilator': 'Ventilator',
    'io_task_problem_future': 'The time cannot be in the future',
    'io_task_problem_too_early': 'This is more than four hours early; it cannot be recorded yet',
    'io_task_problem_reason': 'Choose a reason',
    'io_task_problem_reason_text': 'Describe the reason',
    'io_task_problem_early': 'Say why the dose is given early',
    'io_task_problem_witness': 'Choose the second nurse who witnessed it',
    'io_task_high_alert_infusion_witness': 'This drip contains a high-alert medicine. A second nurse must witness the start, and it cannot be you.',
    'io_task_problem_range': 'Enter a value from {min} to {max}',
    'io_task_fix_problems': 'Check the fields marked in red',
    'io_task_saved': 'Task recorded',
    'io_task_scheduled': 'Scheduled',
    'io_task_recorded': 'Recorded',
    'io_task_not_recorded_yet': 'Not recorded yet',
    'io_task_recorded_at': 'Recorded at',
    'io_task_recorded_by': 'Recorded by',
    'io_task_reason_text': 'Details',
    'io_task_you': 'You',
    'io_task_another_staff_member': 'Another staff member',
    'io_ward_picker_title': 'Ward tasks',
    'io_ward_picker_desc': 'Choose a ward to see what is overdue, due now and coming up for its patients.',
    'io_ward_on_duty': 'On duty',
    'io_ward_none_title': 'No wards to show',
    'io_ward_none_desc': 'You are not on duty on a ward right now. Ask for a ward shift on the roster.',
    'io_ward_not_allowed': 'Your role cannot see ward tasks',
    'io_ward_board_title': 'Ward tasks',
    'io_ward_board_desc': 'Overdue, due now and the next two hours for every patient on this ward.',
    'io_ward_board_desc_named': 'Ward {code}: overdue, due now and the next two hours for every patient.',
    'io_ward_all_wards': 'All wards',
    'io_ward_refresh': 'Refresh',
    'io_ward_switch': 'Your other wards',
    'io_ward_group_overdue': 'Overdue',
    'io_ward_group_due': 'Due now',
    'io_ward_group_next': 'Next {hours} hours',
    'io_ward_empty_overdue': 'Nothing overdue',
    'io_ward_empty_due': 'Nothing due right now',
    'io_ward_empty_next': 'Nothing in the next two hours',
    'io_ward_patient_label': 'Bed {bed}, {patient}',
    'io_ward_mrn': 'MRN {mrn}',
    'io_due_title': 'Ward tasks due',
    'io_due_strip': 'Due now: {due}, overdue: {overdue} on {ward}',
    'io_due_bell_label': 'Ward tasks due now: {due}, overdue: {overdue}',
    'io_form_new_order': 'New order',
    'io_form_choose_hint': 'Choose what to order for this patient',
    'io_form_change_kind': 'Change order type',
    'io_form_opens_section': 'Ordered in its own EMR section',
    'io_form_no_kinds': 'No order forms are switched on',
    'io_form_no_kinds_hint': 'An administrator can switch order forms on in the EMR form settings',
    'io_form_desc_medication': 'Medicines with dose, route and timing',
    'io_form_desc_iv_fluid': 'Drips and infusions by rate or duration',
    'io_form_desc_diet': 'Diet, texture, fluid limit and nil by mouth',
    'io_form_desc_nursing': 'Nursing tasks for the ward, once or on a schedule',
    'io_form_desc_procedure': 'Procedures from the procedures section',
    'io_form_desc_lab': 'Lab tests from the investigations section',
    'io_form_desc_radiology': 'Imaging from the investigations section',
    'io_form_desc_blood_transfusion': 'Blood products with checks for every unit',
    'io_form_desc_oxygen': 'Oxygen device, flow and target saturation',
    'io_form_desc_physiotherapy': 'Physiotherapy sessions each day',
    'io_form_desc_consult': 'Ask a doctor or department to see the patient',
    'io_form_desc_vitals_monitoring': 'How often vitals are taken and what is recorded',
    'io_form_closed': 'This admission is closed, so no new orders can be placed',
    'io_form_no_permission': 'You do not have permission to place inpatient orders',
    'io_form_load_failed': 'The admission could not be opened',
    'io_form_allergies': 'Recorded allergies',
    'io_form_allergy_warning': 'Possible allergy match',
    'io_form_allergy_match': 'Matches the recorded allergy to {substance}',
    'io_form_allergy_conflict': 'Allergy conflict',
    'io_form_conflict': 'The order was not placed',
    'io_form_save_failed': 'The order could not be saved',
    'io_form_save': 'Place order',
    'io_form_saved': 'Order placed',
    'io_form_saved_detail': '{kind} · ward tasks planned: {count}',
    'io_form_section_medicine': 'Medicine',
    'io_form_section_when': 'When to give',
    'io_form_section_fluid': 'Fluid',
    'io_form_section_rate': 'Rate',
    'io_form_section_bags': 'Bags',
    'io_form_section_blood': 'Blood product',
    'io_form_section_diet': 'Diet',
    'io_form_section_task': 'Nursing task',
    'io_form_section_oxygen': 'Oxygen therapy',
    'io_form_section_physio': 'Physiotherapy',
    'io_form_section_consult': 'Consult',
    'io_form_section_vitals': 'Vitals monitoring',
    'io_form_section_timing': 'Priority and start',
    'io_form_priority': 'Priority',
    'io_form_priority_hint': 'Stat orders alert the ward at once',
    'io_form_starts_at': 'Start',
    'io_form_starts_now_hint': 'Leave empty to start now',
    'io_form_stop_at': 'Stop at',
    'io_form_stop_at_hint': 'Optional; otherwise it runs until stopped',
    'io_form_last_dose_hint': 'No doses are planned from this time',
    'io_form_instructions': 'Instructions',
    'io_form_instructions_hint': 'Anything the ward should know, optional',
    'io_form_drug': 'Medicine',
    'io_form_drug_hint': 'Search the formulary or type a name',
    'io_form_dose': 'Dose',
    'io_form_dose_unit': 'Unit',
    'io_form_unit_other': 'Other unit',
    'io_form_route': 'Route',
    'io_form_route_more': 'Other routes',
    'io_form_high_alert': 'High-alert medicine (needs a witness)',
    'io_form_high_alert_hint': 'A second nurse witnesses every dose',
    'io_form_high_alert_badge': 'High alert',
    'io_form_controlled': 'Controlled drug, always treated as high alert',
    'io_form_iv_high_alert': 'Contains a high-alert medicine (needs a witness)',
    'io_form_iv_high_alert_hint': 'Turn on when the fluid or an additive is high alert, such as concentrated potassium, insulin or heparin; a second nurse witnesses the start of each bag',
    'io_form_prn': 'As needed (PRN)',
    'io_form_prn_hint': 'Given only when the indication is met, with no schedule',
    'io_form_prn_indication': 'Give when',
    'io_form_prn_indication_placeholder': 'Pain score above 4',
    'io_form_prn_max': 'Most doses in a day',
    'io_form_how_often': 'How often',
    'io_form_by_frequency': 'Frequency',
    'io_form_by_interval': 'Custom interval',
    'io_form_frequency': 'Frequency',
    'io_form_every': 'Every',
    'io_form_hours': 'Hours',
    'io_form_minutes': 'Minutes',
    'io_form_first_dose_at': 'First dose at',
    'io_form_first_dose_hint': 'Optional; otherwise the next scheduled time',
    'io_form_how_long': 'How long',
    'io_form_end_open': 'Until stopped',
    'io_form_end_days': 'Number of days',
    'io_form_end_time': 'Until a time',
    'io_form_duration_days': 'Duration in days',
    'io_form_freq_once': 'Once',
    'io_form_freq_stat': 'Stat, give now',
    'io_form_freq_od': 'Once a day (OD)',
    'io_form_freq_bd': 'Twice a day (BD)',
    'io_form_freq_tds': 'Three times a day (TDS)',
    'io_form_freq_qds': 'Four times a day (QDS)',
    'io_form_freq_hs': 'At bedtime (HS)',
    'io_form_freq_q1h': 'Every hour',
    'io_form_freq_q2h': 'Every 2 hours',
    'io_form_freq_q3h': 'Every 3 hours',
    'io_form_freq_q4h': 'Every 4 hours',
    'io_form_freq_q6h': 'Every 6 hours',
    'io_form_freq_q8h': 'Every 8 hours',
    'io_form_freq_q12h': 'Every 12 hours',
    'io_form_freq_q24h': 'Every 24 hours',
    'io_form_route_oral': 'Oral',
    'io_form_route_iv': 'Intravenous (IV)',
    'io_form_route_im': 'Intramuscular (IM)',
    'io_form_route_sc': 'Subcutaneous (SC)',
    'io_form_route_sl': 'Sublingual (SL)',
    'io_form_route_buccal': 'Buccal',
    'io_form_route_inhaled': 'Inhaled',
    'io_form_route_nebulised': 'Nebulised',
    'io_form_route_topical': 'Topical',
    'io_form_route_transdermal': 'Transdermal patch',
    'io_form_route_pr': 'Rectal (PR)',
    'io_form_route_pv': 'Vaginal (PV)',
    'io_form_route_ng': 'Nasogastric tube (NG)',
    'io_form_route_peg': 'Gastrostomy tube (PEG)',
    'io_form_route_ophthalmic': 'Eye',
    'io_form_route_otic': 'Ear',
    'io_form_route_nasal': 'Nasal',
    'io_form_route_intradermal': 'Intradermal',
    'io_form_route_epidural': 'Epidural',
    'io_form_route_intrathecal': 'Intrathecal',
    'io_form_route_other': 'Other route',
    'io_form_every_minutes': 'Every {minutes} min',
    'io_form_every_hours': 'Every {hours} h',
    'io_form_duration_minutes': '{minutes} min',
    'io_form_duration_hours': '{hours} h',
    'io_form_duration_hours_minutes': '{hours} h {minutes} min',
    'io_form_runs_for': 'Runs for {duration}',
    'io_form_rate_value': 'Rate {rate} ml per hour',
    'io_form_each_unit_runs': 'Each unit runs for {duration}',
    'io_form_less': 'Fewer',
    'io_form_more': 'More',
    'io_form_fluid': 'Fluid',
    'io_form_fluid_hint': 'Search the formulary or type the fluid',
    'io_form_volume_ml': 'Volume (ml)',
    'io_form_additives': 'Additives',
    'io_form_additive_name': 'Additive',
    'io_form_additive_amount': 'Amount',
    'io_form_add_additive': 'Add additive',
    'io_form_remove_additive': 'Remove additive',
    'io_form_set_by_rate': 'Set by rate',
    'io_form_set_by_duration': 'Set by duration',
    'io_form_rate_ml_h': 'Rate (ml per hour)',
    'io_form_duration': 'Duration',
    'io_form_check_every': 'Check every',
    'io_form_continuous': 'Continuous',
    'io_form_continuous_hint': 'Bag after bag until the order is stopped',
    'io_form_bags': 'Bags',
    'io_form_first_bag_at': 'First bag at',
    'io_form_first_bag_hint': 'Optional; otherwise at the start',
    'io_form_product': 'Blood product',
    'io_form_blood_whole_blood': 'Whole blood',
    'io_form_blood_packed_red_cells': 'Packed red cells',
    'io_form_blood_fresh_frozen_plasma': 'Fresh frozen plasma',
    'io_form_blood_platelets': 'Platelets',
    'io_form_blood_cryoprecipitate': 'Cryoprecipitate',
    'io_form_units': 'Units',
    'io_form_crossmatch': 'Crossmatch reference',
    'io_form_volume_per_unit': 'Volume per unit (ml)',
    'io_form_minutes_per_unit': 'Minutes per unit',
    'io_form_default_minutes': 'Usual time for this product: {minutes} min',
    'io_form_indication': 'Indication',
    'io_form_first_unit_at': 'First unit at',
    'io_form_first_unit_hint': 'Vitals are taken at this time and the unit starts 15 minutes later',
    'io_form_diet_type': 'Diet',
    'io_form_diet_normal': 'Normal diet',
    'io_form_diet_diabetic': 'Diabetic diet',
    'io_form_diet_renal': 'Renal diet',
    'io_form_diet_cardiac': 'Cardiac diet',
    'io_form_diet_soft': 'Soft diet',
    'io_form_diet_liquid': 'Liquid diet',
    'io_form_diet_npo': 'Nil by mouth',
    'io_form_diet_high_protein': 'High protein',
    'io_form_diet_low_salt': 'Low salt',
    'io_form_texture': 'Texture',
    'io_form_texture_regular': 'Regular',
    'io_form_texture_soft': 'Soft',
    'io_form_texture_minced': 'Minced',
    'io_form_texture_pureed': 'Pureed',
    'io_form_texture_liquid': 'Liquid',
    'io_form_fluid_restriction': 'Fluid limit (ml per day)',
    'io_form_no_limit': 'No limit',
    'io_form_npo_from': 'Nil by mouth from',
    'io_form_npo_until': 'Nil by mouth until',
    'io_form_diet_notes': 'Notes for the kitchen',
    'io_form_diet_replaces': 'A new diet order replaces the running one',
    'io_form_task': 'Task',
    'io_form_task_placeholder': 'Change the wound dressing',
    'io_form_device': 'Device',
    'io_form_device_nasal_cannula': 'Nasal cannula',
    'io_form_device_simple_mask': 'Simple face mask',
    'io_form_device_venturi_mask': 'Venturi mask',
    'io_form_device_non_rebreather': 'Non-rebreather mask',
    'io_form_device_high_flow_nasal': 'High-flow nasal',
    'io_form_device_cpap': 'CPAP',
    'io_form_device_bipap': 'BiPAP',
    'io_form_device_ventilator': 'Ventilator',
    'io_form_flow': 'Flow (litres per minute)',
    'io_form_fio2': 'Oxygen fraction FiO2 (%)',
    'io_form_flow_or_fio2': 'Give the flow, the FiO2 or both',
    'io_form_target_spo2': 'Target saturation',
    'io_form_spo2_range': '{min} to {max}%',
    'io_form_spo2_min': 'Lowest SpO2 (%)',
    'io_form_spo2_max': 'Highest SpO2 (%)',
    'io_form_physio_type': 'Therapy',
    'io_form_physio_chest': 'Chest physiotherapy',
    'io_form_physio_mobilisation': 'Mobilisation',
    'io_form_physio_limb_exercises': 'Limb exercises',
    'io_form_physio_gait_training': 'Gait training',
    'io_form_physio_positioning': 'Positioning',
    'io_form_physio_other': 'Other',
    'io_form_sessions_per_day': 'Sessions a day',
    'io_form_physio_days_hint': 'Optional; otherwise until stopped',
    'io_form_notes': 'Notes',
    'io_form_consult_target': 'Who to consult',
    'io_form_target_doctor': 'A doctor',
    'io_form_target_department': 'A department',
    'io_form_search_doctors': 'Search doctors',
    'io_form_no_doctors': 'No doctors match',
    'io_form_department': 'Department',
    'io_form_choose_department': 'Choose a department',
    'io_form_specialty': 'Specialty, optional',
    'io_form_urgency': 'Urgency',
    'io_form_urgency_routine': 'Routine',
    'io_form_urgency_urgent': 'Urgent',
    'io_form_urgency_emergency': 'Emergency',
    'io_form_question': 'Question for the consultant',
    'io_form_vitals_interval': 'Take vitals',
    'io_form_custom': 'Custom',
    'io_form_custom_minutes': 'Every how many minutes',
    'io_form_parameters': 'What to record',
    'io_form_param_bp': 'Blood pressure',
    'io_form_param_pulse': 'Pulse',
    'io_form_param_respiratory_rate': 'Breathing rate',
    'io_form_param_temperature': 'Temperature',
    'io_form_param_spo2': 'Oxygen saturation',
    'io_form_param_pain': 'Pain score',
    'io_form_param_blood_sugar': 'Blood sugar',
    'io_form_param_consciousness': 'Consciousness (AVPU)',
    'io_form_vitals_replaces': 'This replaces the running vitals monitoring order',
    'io_form_err_required': 'Fill this in',
    'io_form_err_too_short': 'Enter at least {min} characters',
    'io_form_err_too_long': 'Keep it to {max} characters or fewer',
    'io_form_err_min': 'Enter {min} or more',
    'io_form_err_above': 'Enter more than {min}',
    'io_form_err_max': 'Enter {max} or less',
    'io_form_err_whole': 'Enter a whole number',
    'io_form_err_invalid': 'Check this value',
    'io_form_preview': 'Schedule preview',
    'io_form_preview_hint': 'First 48 hours from the start',
    'io_form_preview_count': 'Ward tasks in 48 hours: {count}',
    'io_form_preview_more': 'Showing the first {shown} of {total}',
    'io_form_preview_beyond': 'The schedule carries on after 48 hours',
    'io_form_preview_prn': 'As-needed medicine: nothing is scheduled, the nurse gives it when the indication is met',
    'io_form_preview_none': 'This order creates no ward tasks',
    'io_form_preview_incomplete': 'Fill in the order to see its schedule',
    'io_form_bag_number': 'Bag {number}',
    'io_form_unit_number': 'Unit {number}',
    'io_form_step_pre_vitals': 'Vitals before',
    'io_form_step_start': 'Start',
    'io_form_step_check_15': '15-minute check',
    'io_form_step_check': 'Hourly check',
    'io_form_step_end': 'End',
    'io_form_step_post_vitals': 'Vitals after',
    'io_form_meal_breakfast': 'Breakfast',
    'io_form_meal_lunch': 'Lunch',
    'io_form_meal_dinner': 'Dinner',
    'io_form_meal_other': 'Meal',
    'io_form_initial_check': 'First check',
    'sp_labour_title': 'Labour & delivery',
    'sp_labour_description': 'Partograph, delivery notes and the birth register',
    'sp_open_labour_record': 'Open a labour record',
    'sp_in_labour': 'In labour',
    'sp_delivered': 'Delivered',
    'sp_babies': 'Babies',
    'sp_no_labour_records': 'No labour records.',
    'sp_mother': 'Mother',
    'sp_gravida_para': 'G/P',
    'sp_gestation': 'Gestation',
    'sp_weeks_short': '{weeks} wk',
    'sp_x_weeks': '{weeks} weeks',
    'sp_onset': 'Onset',
    'sp_mode': 'Mode',
    'sp_observation_recorded': 'Observation recorded',
    'sp_could_not_record': 'Could not record it',
    'sp_baby_registered': 'Baby registered',
    'sp_baby_has_mrn': 'They now have their own MRN',
    'sp_could_not_register_baby': 'Could not register the baby',
    'sp_labour_record': 'Labour record',
    'sp_record_delivery': 'Record delivery',
    'sp_new_observation': 'New observation',
    'sp_cervix_cm': 'Cervix (cm)',
    'sp_contractions_per_10': 'Contractions /10',
    'sp_foetal_heart': 'Foetal heart',
    'sp_liquor': 'Liquor',
    'sp_partograph': 'Partograph',
    'sp_no_observations': 'No observations recorded yet.',
    'sp_at': 'At',
    'sp_cervix': 'Cervix',
    'sp_contractions': 'Contractions',
    'sp_newborns': 'Newborns',
    'sp_born': 'Born',
    'sp_sex': 'Sex',
    'sp_weight': 'Weight',
    'sp_apgar': 'APGAR',
    'sp_registered': 'Registered',
    'sp_give_mrn': 'Give an MRN',
    'sp_session_started': 'Session started',
    'sp_could_not_start_session': 'Could not start the session',
    'sp_therapy_title': 'Therapy units',
    'sp_therapy_description': 'Dialysis, chemotherapy and physiotherapy sessions',
    'sp_book_session': 'Book a session',
    'sp_stations': 'Stations',
    'sp_booked_today': 'Booked today',
    'sp_running': 'Running',
    'sp_completed': 'Completed',
    'sp_unit': 'Unit',
    'sp_date': 'Date',
    'sp_nothing_booked': 'Nothing booked for this day.',
    'sp_time': 'Time',
    'sp_session': 'Session',
    'sp_station': 'Station',
    'sp_unassigned': 'Unassigned',
    'sp_cycle': 'Cycle',
    'sp_protocol': 'Protocol',
    'sp_start': 'Start',
    'sp_complete': 'Complete',
    'sp_session_completed': 'Session completed',
    'sp_charge_on_bill': 'The charge is on the patient bill',
    'sp_complete_session': 'Complete the session',
    'sp_pre_session_weight': 'Pre-session weight {weight} kg',
    'sp_weight_removed': 'Removed {weight} kg',
    'sp_post_session_weight': 'Post-session weight (kg)',
    'sp_complications': 'Complications',
    'sp_upper_right': 'Upper right',
    'sp_upper_left': 'Upper left',
    'sp_lower_right': 'Lower right',
    'sp_lower_left': 'Lower left',
    'sp_dental': 'Dental',
    'sp_dental_description': 'Tooth charting and multi-visit treatment plans',
    'sp_tooth_chart': 'Tooth chart (FDI notation)',
    'sp_healthy': 'Healthy',
    'sp_nothing_charted': 'Nothing charted for this patient.',
    'sp_tooth': 'Tooth',
    'sp_finding': 'Finding',
    'sp_procedure': 'Procedure',
    'sp_surfaces': 'Surfaces',
    'sp_planned': 'Planned',
};
//# sourceMappingURL=ipd.js.map